<template>
	<div class="report_container full">
		<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
		<list-index :knowledgetype="knowledgetype" :goodscode="goodscode" ref="listIndex" />
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import listIndex from './knowledge/list.vue'
	export default {
		mixins: [listMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				knowledgetype:'goodsbase',
				goodscode:'',
				list_formConfig: [{
						field: 'itemId',
						title: '编码',
						itemRender: {
							name: '$input',
							props:{}
						}
					},{
						field: 'itemTitle',
						title: '名称',
						itemRender: {
							name: '$input',
							props:{}
						}
					}
				],
				list_columns: [
					{
						field: 'itemId',
						title: '编码',
					},
					{
						field: 'itemTitle',
						title: '名称',
					},
					{
						field: 'num',
						title: '知识数量',
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 135,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.knowledge(row)}}>知识</el-button>
								]
							}
						}
					}					
				]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.id = 'goodscommon_list'
				gridOptions.pagerConfig = {
					enabled: true,
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50,100],
				}
				gridOptions.toolbarConfig.buttons = []
				
				
				gridOptions.formConfig.span = 4
			},
			list(page,updateForm,other) {
				return new Promise((resolve) => {
					this.$api.goodsknowledge.list({
						...page,
						...updateForm,
						...other,
						...{knowledgetype:this.knowledgetype}
					}).then((res)=>{
						resolve(res)
					})
				})
			},
			knowledge(row){
				this.goodscode = row.realitemId
				this.$refs.listIndex.modal_show()
			},
			jump(row){
				window.open(row.itemUrl, '_blank')
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			listIndex
		}
	}
</script>